import { z } from 'zod';

export enum VCycleElementContainerFilterConditionSelector {
    PROCESS_AREA_ROLE = 'PROCESS_AREA_ROLE',
    RELEVANT_ROLE = 'RELEVANT_ROLE',
    CRITERIA = 'CRITERIA',
    PROCESS_ARTIFACT = 'PROCESS_ARTIFACT',
    OBJECTIVE = 'OBJECTIVE',
    METHOD = 'METHOD',
    TOOL = 'TOOL',
    VERIFICATION_METRIC = 'VERIFICATION_METRIC',
}

export const VCycleElementContainerFilterConditionSelectorSchema = z.enum(
    VCycleElementContainerFilterConditionSelector
);
